import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ApiClientErrorHandlersContext, } from './api-client-error-handlers-context';
export function ApiClientErrorHandlersProvider({ children, onForbidden, }) {
    const value = useMemo(() => ({ onForbidden }), [onForbidden]);
    return (_jsx(ApiClientErrorHandlersContext.Provider, { value: value, children: children }));
}
